import { render, staticRenderFns } from "./InventoryLabResultView.vue?vue&type=template&id=3a605598"
import script from "./InventoryLabResultView.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a605598')) {
      api.createRecord('3a605598', component.options)
    } else {
      api.reload('3a605598', component.options)
    }
    module.hot.accept("./InventoryLabResultView.vue?vue&type=template&id=3a605598", function () {
      api.rerender('3a605598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryLabResult/InventoryLabResultView.vue"
export default component.exports